import * as React from 'react'

export function BuyMeACoffeeIcon({
  size = 24,
  color = 'currentColor',
  className,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  size?: number
  color?: string
}) {
  return (
    <svg
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      className={className}
      {...props}
    >
      <title>Buy Me a Coffee</title>
      <path d="M20.216 6.415l-.132-.666c-.119-.598-.388-1.15-1.064-1.15H14.75v-1.95c0-.846-.74-1.524-1.586-1.524H7.33c-.846 0-1.586.678-1.586 1.524v1.95h-4.27c-.676 0-1.045.552-1.064 1.15l-.132.666c-.015.078-.024.156-.024.234v8.182c0 .888.732 1.614 1.62 1.614h17.12c.888 0 1.62-.726 1.62-1.614V6.649c0-.078-.009-.156-.024-.234zm-6.852 8.074h-2.016v-2.016h2.016v2.016zm0-3.048h-2.016v-2.016h2.016v2.016zm0-3.048h-2.016v-2.016h2.016v2.016z" />
    </svg>
  )
}
